module.exports = __webpack_public_path__ + "img/tooth-missing.3dda774a.svg";